import React, { useState } from "react";
import "./Sidebar.css";
import { IoChevronBackSharp } from "react-icons/io5";
import { Auth } from "../../../config/aws-exports";
import { getCookie, setCookie } from "../../../shared/helpers";
import { updateUserInfo } from "../../../redux/actions";
import history from "../../../routes/history";
import { connect } from "react-redux";

const Sidebar = (props) => {

  const onLogOut = async () => {
    try {
      // .then(data => console.log(data))
      // .catch(err => console.log(err));
      setCookie("token", "");
      setCookie("RememberMe", "false");
      window.localStorage.removeItem('AboutMessage');
      window.localStorage.removeItem("redirectUrl");
      props.sendAuthToken(null);
      props.hide();
      props.changeStage('')
      window.localStorage.removeItem('showDisclaimer')
      await Auth.signOut();
      history.push("/login");
      // window.location.reload();
    } catch (error) {
      history.push("/login");
    }
  };

  // const onLogOut = async() =>{
  //   console.log("clicked")
  //   try {
  //     const done = await Auth.signOut();
  //     console.log(done);
  //     if (done) {
  //       let token = ""
  //       setCookie("token", token);
  //       history.push("/login");
  //       console.log("Logges out")
  //     }
  // } catch (error) {
  //     console.log('error signing out: ', error);
  // }
  // }
  // useEffect(async () => {
  //   const session = await Auth.currentSession();
  //   if (session) {
  //     let token = session.getIdToken().getJwtToken();
  //     setCookie("token", token);
  //     props.sendAuthToken(token);
  //   }
  //
  // }, []);

  return (
    <div className="container-sidebar">
      {/* <button style={{color:"black", height:"2rem", width:"2rem", visibility: {mystate}}} onClick={clicked}>Hey</button> */}
      <div className="sidenav">
        {/* <IoChevronBackSharp className="icon"/> */}
        {/* <div className="back">Back</div> */}
        <div className="profilename-sidebar">{props.profile}</div>
        {/* <a href="#section" className="complete-profile">Complete profile</a> */}
      </div>
      <a className="logOut-sidebar" onClick={onLogOut}>
        Logout
      </a>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.profileReducer.user.name,
    error: state.profileReducer.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendAuthToken: (params) => {
      dispatch(updateUserInfo(params)); // action dispatched
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
